module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('b-modal', {
    attrs: {
      "id": "modal-auth",
      "title": "实例授权",
      "scrollable": ""
    },
    scopedSlots: _vm._u([{
      key: "modal-footer",
      fn: function(ref) {
        var cancel = ref.cancel;

        return [_c('b-button', {
          attrs: {
            "size": "sm",
            "variant": "danger"
          },
          on: {
            "click": function($event) {
              return cancel()
            }
          }
        }, [_vm._v("\n      取消\n    ")]), _vm._v(" "), _c('b-button', {
          attrs: {
            "size": "sm",
            "variant": "success"
          },
          on: {
            "click": _vm.auth
          }
        }, [_vm._v("\n      提交\n    ")])]
      }
    }]),
    model: {
      value: (_vm.modalShow),
      callback: function($$v) {
        _vm.modalShow = $$v
      },
      expression: "modalShow"
    }
  }, [_c('b-form-checkbox-group', {
    attrs: {
      "options": _vm.items,
      "name": "flavour-2a",
      "stacked": ""
    },
    model: {
      value: (_vm.selected),
      callback: function($$v) {
        _vm.selected = $$v
      },
      expression: "selected"
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler.js?id=data-v-d16493e6!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Vote/VoteAuth.vue
// module id = KoyL
// module chunks = 4